export const accountTeamSearchParams = (team: string): string => {
	if (team.trim().length > 0) {
		return decodeURIComponent(team.trim())
	}
	return ''
}